module.exports = __webpack_public_path__ + "img/num_30.5c28971c.png";